export default __webpack_public_path__ + "static/media/honesty2Img4.3a9131ba.png";